import DiscountCreate from "../pages/discount/addDiscount";
import DiscountIndex from "../pages/discount/discocunt";
import DiscountEdit from "../pages/discount/editDiscount";

const discountRoutes = [
  {
    path: "discount",
    element: <DiscountIndex />,
  },
  {
    path: "discounts/add",
    element: <DiscountCreate />,
  },
  {
    path: "discounts/edit/:id",
    element: <DiscountEdit />,
  },
];

export default discountRoutes;